export class EnvironmentParameter {
  production = false;
  SERVER_URL = '/c4c3';
  LAYOUT_STYLE = 'sidebar';
  RELEASE_LOG = 'https://www.yuque.com/xcollege/updates_cfa';
  MAIN_URL?: string;

  /**==付款组件：module config=======**/
  //PAYMENT_EXTERNAL_APPLY = true; // 付款申请：获取数据
  //PAYMENT_FOREIGN_APPLY = true; // 付款申请：外汇支付单上传
  ACL_FULL_PERMISSION = false;
  //PAYMENT_REVOCATION_APPLY = true; // 付款申请：撤回按钮

  /**==IFrame变量==**/
  IFrameHost = 'http://localhost/2022CFA.html#!/';

  /**==银企直联==**/
  BANK_ENTERPRISE_LINK_MORE = true;
}
